import {
  BillingAddOnPricing,
  BillingPackagePricing,
  ProductsList as ProductsListResponse,
  CurrencyType,
  BillingCycle,
  PriceBillingScheme,
  BillingAddOnProductCategoryEnum,
  BillingPackageProductCategoryEnum,
} from '@electricjs/core_entity-client';

/**
 * Mock product data for testing convertProductsToCamelCase function
 */

// Mock package that should be filtered out (disallowed)
const mockDisallowedPackage: BillingPackagePricing = {
  package: {
    name: 'Electric IT Management Essentials (Billed by ADP)',
    active: true,
    unit_label: 'license',
    vendor: 'Electric',
    brand: 'Electric',
    created_at: '2023-01-01T00:00:00Z',
    product_category: BillingPackageProductCategoryEnum.Package,
    product_id: 'package-essentials-adp',
    package_id: 'c882b008-e858-440c-b0b3-8fcd7444a7a7', // Disallowed ID
    quotable: false,
  },
  pricing: {
    product_id: 'package-essentials-adp',
    currency: CurrencyType.Usd,
    month_price: {
      price_id: 'price-month-1',
      product: {
        name: 'Electric IT Management Essentials (Billed by ADP)',
        active: true,
        unit_label: 'license',
        vendor: 'Electric',
        brand: 'Electric',
        created_at: '2023-01-01T00:00:00Z',
        product_category: BillingPackageProductCategoryEnum.Package,
        product_id: 'package-essentials-adp',
        package_id: 'c882b008-e858-440c-b0b3-8fcd7444a7a7',
        quotable: false,
      },
      active: true,
      billing_scheme: PriceBillingScheme.PerUnit,
      billing_cycle: BillingCycle.Month,
      price_value: {
        unit_price: { value: 100, currency: CurrencyType.Usd },
      },
      created_at: '2023-01-01T00:00:00Z',
    },
    quarter_price: {
      price_id: 'price-quarter-1',
      product: {
        name: 'Electric IT Management Essentials (Billed by ADP)',
        active: true,
        unit_label: 'license',
        vendor: 'Electric',
        brand: 'Electric',
        created_at: '2023-01-01T00:00:00Z',
        product_category: BillingPackageProductCategoryEnum.Package,
        product_id: 'package-essentials-adp',
        package_id: 'c882b008-e858-440c-b0b3-8fcd7444a7a7',
        quotable: false,
      },
      active: true,
      billing_scheme: PriceBillingScheme.PerUnit,
      billing_cycle: BillingCycle.Quarter,
      price_value: {
        unit_price: { value: 270, currency: CurrencyType.Usd },
      },
      created_at: '2023-01-01T00:00:00Z',
    },
    year_price: {
      price_id: 'price-year-1',
      product: {
        name: 'Electric IT Management Essentials (Billed by ADP)',
        active: true,
        unit_label: 'license',
        vendor: 'Electric',
        brand: 'Electric',
        created_at: '2023-01-01T00:00:00Z',
        product_category: BillingPackageProductCategoryEnum.Package,
        product_id: 'package-essentials-adp',
        package_id: 'c882b008-e858-440c-b0b3-8fcd7444a7a7',
        quotable: false,
      },
      active: true,
      billing_scheme: PriceBillingScheme.PerUnit,
      billing_cycle: BillingCycle.Year,
      price_value: {
        unit_price: { value: 1000, currency: CurrencyType.Usd },
      },
      created_at: '2023-01-01T00:00:00Z',
    },
  },
};

// Mock package that should be included (allowed)
const mockAllowedPackage: BillingPackagePricing = {
  package: {
    name: 'Electric IT Management Pro',
    active: true,
    unit_label: 'license',
    vendor: 'Electric',
    brand: 'Electric',
    created_at: '2023-01-01T00:00:00Z',
    product_category: BillingPackageProductCategoryEnum.Package,
    product_id: 'package-pro',
    package_id: 'allowed-package-id',
    quotable: true,
  },
  pricing: {
    product_id: 'package-pro',
    currency: CurrencyType.Usd,
    month_price: {
      price_id: 'price-month-2',
      product: {
        name: 'Electric IT Management Pro',
        active: true,
        unit_label: 'license',
        vendor: 'Electric',
        brand: 'Electric',
        created_at: '2023-01-01T00:00:00Z',
        product_category: BillingPackageProductCategoryEnum.Package,
        product_id: 'package-pro',
        package_id: 'allowed-package-id',
        quotable: true,
      },
      active: true,
      billing_scheme: PriceBillingScheme.PerUnit,
      billing_cycle: BillingCycle.Month,
      price_value: {
        unit_price: { value: 200, currency: CurrencyType.Usd },
      },
      created_at: '2023-01-01T00:00:00Z',
    },
    quarter_price: {
      price_id: 'price-quarter-2',
      product: {
        name: 'Electric IT Management Pro',
        active: true,
        unit_label: 'license',
        vendor: 'Electric',
        brand: 'Electric',
        created_at: '2023-01-01T00:00:00Z',
        product_category: BillingPackageProductCategoryEnum.Package,
        product_id: 'package-pro',
        package_id: 'allowed-package-id',
        quotable: true,
      },
      active: true,
      billing_scheme: PriceBillingScheme.PerUnit,
      billing_cycle: BillingCycle.Quarter,
      price_value: {
        unit_price: { value: 540, currency: CurrencyType.Usd },
      },
      created_at: '2023-01-01T00:00:00Z',
    },
    year_price: {
      price_id: 'price-year-2',
      product: {
        name: 'Electric IT Management Pro',
        active: true,
        unit_label: 'license',
        vendor: 'Electric',
        brand: 'Electric',
        created_at: '2023-01-01T00:00:00Z',
        product_category: BillingPackageProductCategoryEnum.Package,
        product_id: 'package-pro',
        package_id: 'allowed-package-id',
        quotable: true,
      },
      active: true,
      billing_scheme: PriceBillingScheme.PerUnit,
      billing_cycle: BillingCycle.Year,
      price_value: {
        unit_price: { value: 2000, currency: CurrencyType.Usd },
      },
      created_at: '2023-01-01T00:00:00Z',
    },
  },
};

// Mock add-on that should be filtered out (disallowed)
const mockDisallowedAddOn: BillingAddOnPricing = {
  add_on: {
    name: 'ADP Data Connector (Billed by ADP)',
    active: true,
    unit_label: 'license',
    vendor: 'ADP',
    brand: 'ADP',
    created_at: '2023-01-01T00:00:00Z',
    product_category: BillingAddOnProductCategoryEnum.AddOn,
    product_id: 'addon-adp-connector',
    add_on_id: '587e86c8-e63f-4ac8-b585-bb7d71c3a8d9', // Disallowed ID
    vendor_product_id: 'adp-123',
    vendor_product_sku: 'ADP-CONN-001',
    quotable: false,
  },
  pricing: {
    product_id: 'addon-adp-connector',
    currency: CurrencyType.Usd,
    month_price: {
      price_id: 'price-month-3',
      product: {
        name: 'ADP Data Connector (Billed by ADP)',
        active: true,
        unit_label: 'license',
        vendor: 'ADP',
        brand: 'ADP',
        created_at: '2023-01-01T00:00:00Z',
        product_category: BillingAddOnProductCategoryEnum.AddOn,
        product_id: 'addon-adp-connector',
        add_on_id: '587e86c8-e63f-4ac8-b585-bb7d71c3a8d9',
        vendor_product_id: 'adp-123',
        vendor_product_sku: 'ADP-CONN-001',
        quotable: false,
      },
      active: true,
      billing_scheme: PriceBillingScheme.PerUnit,
      billing_cycle: BillingCycle.Month,
      price_value: {
        unit_price: { value: 50, currency: CurrencyType.Usd },
      },
      created_at: '2023-01-01T00:00:00Z',
    },
    quarter_price: {
      price_id: 'price-quarter-3',
      product: {
        name: 'ADP Data Connector (Billed by ADP)',
        active: true,
        unit_label: 'license',
        vendor: 'ADP',
        brand: 'ADP',
        created_at: '2023-01-01T00:00:00Z',
        product_category: BillingAddOnProductCategoryEnum.AddOn,
        product_id: 'addon-adp-connector',
        add_on_id: '587e86c8-e63f-4ac8-b585-bb7d71c3a8d9',
        vendor_product_id: 'adp-123',
        vendor_product_sku: 'ADP-CONN-001',
        quotable: false,
      },
      active: true,
      billing_scheme: PriceBillingScheme.PerUnit,
      billing_cycle: BillingCycle.Quarter,
      price_value: {
        unit_price: { value: 135, currency: CurrencyType.Usd },
      },
      created_at: '2023-01-01T00:00:00Z',
    },
    year_price: {
      price_id: 'price-year-3',
      product: {
        name: 'ADP Data Connector (Billed by ADP)',
        active: true,
        unit_label: 'license',
        vendor: 'ADP',
        brand: 'ADP',
        created_at: '2023-01-01T00:00:00Z',
        product_category: BillingAddOnProductCategoryEnum.AddOn,
        product_id: 'addon-adp-connector',
        add_on_id: '587e86c8-e63f-4ac8-b585-bb7d71c3a8d9',
        vendor_product_id: 'adp-123',
        vendor_product_sku: 'ADP-CONN-001',
        quotable: false,
      },
      active: true,
      billing_scheme: PriceBillingScheme.PerUnit,
      billing_cycle: BillingCycle.Year,
      price_value: {
        unit_price: { value: 500, currency: CurrencyType.Usd },
      },
      created_at: '2023-01-01T00:00:00Z',
    },
  },
};

// Mock add-on that should be included (allowed)
const mockAllowedAddOn: BillingAddOnPricing = {
  add_on: {
    name: 'Security Monitoring',
    active: true,
    unit_label: 'license',
    vendor: 'Electric',
    brand: 'Electric',
    created_at: '2023-01-01T00:00:00Z',
    product_category: BillingAddOnProductCategoryEnum.AddOn,
    product_id: 'addon-security',
    add_on_id: 'allowed-addon-id',
    vendor_product_id: 'sec-123',
    vendor_product_sku: 'SEC-MON-001',
    quotable: true,
  },
  pricing: {
    product_id: 'addon-security',
    currency: CurrencyType.Usd,
    month_price: {
      price_id: 'price-month-4',
      product: {
        name: 'Security Monitoring',
        active: true,
        unit_label: 'license',
        vendor: 'Electric',
        brand: 'Electric',
        created_at: '2023-01-01T00:00:00Z',
        product_category: BillingAddOnProductCategoryEnum.AddOn,
        product_id: 'addon-security',
        add_on_id: 'allowed-addon-id',
        vendor_product_id: 'sec-123',
        vendor_product_sku: 'SEC-MON-001',
        quotable: true,
      },
      active: true,
      billing_scheme: PriceBillingScheme.PerUnit,
      billing_cycle: BillingCycle.Month,
      price_value: {
        unit_price: { value: 75, currency: CurrencyType.Usd },
      },
      created_at: '2023-01-01T00:00:00Z',
    },
    quarter_price: {
      price_id: 'price-quarter-4',
      product: {
        name: 'Security Monitoring',
        active: true,
        unit_label: 'license',
        vendor: 'Electric',
        brand: 'Electric',
        created_at: '2023-01-01T00:00:00Z',
        product_category: BillingAddOnProductCategoryEnum.AddOn,
        product_id: 'addon-security',
        add_on_id: 'allowed-addon-id',
        vendor_product_id: 'sec-123',
        vendor_product_sku: 'SEC-MON-001',
        quotable: true,
      },
      active: true,
      billing_scheme: PriceBillingScheme.PerUnit,
      billing_cycle: BillingCycle.Quarter,
      price_value: {
        unit_price: { value: 202.5, currency: CurrencyType.Usd },
      },
      created_at: '2023-01-01T00:00:00Z',
    },
    year_price: {
      price_id: 'price-year-4',
      product: {
        name: 'Security Monitoring',
        active: true,
        unit_label: 'license',
        vendor: 'Electric',
        brand: 'Electric',
        created_at: '2023-01-01T00:00:00Z',
        product_category: BillingAddOnProductCategoryEnum.AddOn,
        product_id: 'addon-security',
        add_on_id: 'allowed-addon-id',
        vendor_product_id: 'sec-123',
        vendor_product_sku: 'SEC-MON-001',
        quotable: true,
      },
      active: true,
      billing_scheme: PriceBillingScheme.PerUnit,
      billing_cycle: BillingCycle.Year,
      price_value: {
        unit_price: { value: 750, currency: CurrencyType.Usd },
      },
      created_at: '2023-01-01T00:00:00Z',
    },
  },
};

export const mockProductsListResponse: ProductsListResponse = {
  packages: [mockDisallowedPackage, mockAllowedPackage],
  add_ons: [mockDisallowedAddOn, mockAllowedAddOn],
};

export const mockProductsListWithOnlyAllowed: ProductsListResponse = {
  packages: [mockAllowedPackage],
  add_ons: [mockAllowedAddOn],
};

export const mockProductsListWithOnlyDisallowed: ProductsListResponse = {
  packages: [mockDisallowedPackage],
  add_ons: [mockDisallowedAddOn],
};
